const BASE_DOMAIN = '0account.com';

export const environment = {
  production: true,
  environment: 'production',
  // Off until a client release that sends user_code has reached customers.
  // An app requesting KYC before then gives its users a sign-in that cannot
  // complete. Flip to true with that release, not before.
  kyc_field_enabled: false,
  appId: 'd0f78877-105c-467a-963e-f987b6e16c16',
  ws_url: `ws://${BASE_DOMAIN}/ws`,
  site_url: `https://${BASE_DOMAIN}`,
  api_url: `https://v1.${BASE_DOMAIN}`,
  // Prefix the API puts on its cookies; the CSRF one is read by the interceptor.
  cookie_prefix: '0account',
  docs_url: `https://docs.${BASE_DOMAIN}`,
  portal_url: `https://my.${BASE_DOMAIN}`,
  stripe_publishable_key:
    'pk_live_51H6j93LCNsiTHKzWAUPl5rERgrXslKH9JpWtPNCSN91pJui9XfED7RpPD6HbCmwWZLsg050gFzI9ZG0M5OUH80nu00jazzgTHg',
  sentry: {
    enabled: true,
    dsn: 'https://263af81fec37404e8fe79ce6c3cfc868@o942961.ingest.sentry.io/4504463661072384',
  },
};
